import { HttpClient, HttpContext, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConverterService, OCC_HTTP_TOKEN, OccEndpointsService, OccProductSearchAdapter, PRODUCT_SEARCH_PAGE_NORMALIZER, ProductSearchPage, SearchConfig } from "@spartacus/core";
import { Observable } from "rxjs";
import { StorageService } from "../../../SGRE-shared/services/storage.service";

@Injectable()
export class CustomOccProductSearchAdapter extends OccProductSearchAdapter {
    constructor(
        protected override http: HttpClient,
        protected override occEndpoints: OccEndpointsService,
        protected override converter: ConverterService,
        private storageService: StorageService
    ) {
        super(http, occEndpoints, converter);
    }

    public override search(
        query: string,
        searchConfig: SearchConfig = this.DEFAULT_SEARCH_CONFIG
    ): Observable<ProductSearchPage> {
        const context = new HttpContext().set(OCC_HTTP_TOKEN, {
            sendUserIdAsHeader: true,
        });

        let headers = new HttpHeaders();
        const legalEntityId: string = this.storageService.defaultLegalEntity?.uid;
        if (legalEntityId?.length > 0) {
            headers = headers.set('legalEntity', legalEntityId);
        }

        return this.http
            .get(this.getSearchEndpoint(query, searchConfig), { headers, context })
            .pipe(this.converter.pipeable(PRODUCT_SEARCH_PAGE_NORMALIZER));
    }
}